import restApi from "@plannel/services/utils/rest-api";

const getAll = (params) => {
  return restApi.post("/api/customerhrchies", params);
};

const getAllForCSV = params => {
  return restApi.post("/api/customerhrchies", params);
};

const get = id => {
  return restApi.get(`/api/customerhrchies/${id}`);
};

const getByConfig = (params) => {
  return restApi.get("/api/customerhrchies/config", { params });
};

const upsert = data => {
  return restApi.post("/api/customerhrchies/save", data);
};

const remove = ids => {
  return restApi.delete(`/api/customerhrchies/${ids}`);
};

const getLookup = params => {
  return restApi.get("/api/customerhrchies/leaf", { params })
};

const getHrchyClsr = () => {
  return restApi.get("/api/customerhrchy-clsr");
};

const getTopHrchy = params => {
  return restApi.get("/api/customerhrchies/top", { params });
};

const getAllByFilter = () => {
  return restApi.get("/api/customerhrchies/all");
};

const getHrchyFilter = params => {
  return restApi.get("/api/customerhrchies/filter", { params });
};

const customerHrchyService = {
  getAll,
  getAllForCSV,
  getByConfig,
  get,
  upsert,
  remove,
  getLookup,
  getHrchyClsr,
  getTopHrchy,
  getAllByFilter,
  getHrchyFilter
};

export default customerHrchyService;